import React from 'react';
import styles from './NotAvaliable.module.css';

const NotAvaliable = () => {
    return (
        <section id="not-avaliable" className={styles.notAvaliable}>
            <h2>Благодарим за интереса! За съжаление продуктът не е наличен в момента!</h2>
        </section>
    );
};

export default NotAvaliable;
